import { getBackVersion } from '../../../config';
import api from '../../api';
import { RentAdvanceOfferSnapshot } from '../../../models/LandlordArea/RentAdvance';

const getOffers = (
    rentAdvanceId: number
): Promise<RentAdvanceOfferSnapshot[]> =>
    api.request<RentAdvanceOfferSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/offers`,
    });

const getOfferChoice = (
    rentAdvanceId: number
): Promise<RentAdvanceOfferSnapshot> =>
    api.request<RentAdvanceOfferSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/offer_choice`,
    });

export { getOffers, getOfferChoice };
